document.addEventListener('form_reset', (e) => {
	e.detail.initiator.reset();
});


